import UAParser from 'ua-parser-js';
import { isVault } from '~/components/Dosi/Vault';

export const ua = UAParser();

export const isMobileDevice = ['mobile', 'tablet'].includes(ua.device.type || '');

export const isIosDevice = ['iOS'].includes(ua.os.name || '');

export const isVaultIosDevice = isIosDevice && isVault;
